import { trackOpenChatListItemClick } from './tracking';
import { currentOpenChatIDSelector, selectChats } from '../../selectors';
import { TThunkAction } from '../../types/redux/thunk';
import { updateChatImages } from '../chatImages';
import { increaseCountClosedChats } from '../chatWindow';
import { sendMailingUxfeedbackCampaign } from '../mailingUxfeedback';
import { updateMessages } from '../messages/updateMessages';
import { getChatUserByRole } from '../../utils/getChatUserByRole';

type TOpenChatFromListItemParams = {
  chatId: string;
  isMobile: boolean;
};

export const openChatFromListItem =
  ({ chatId, isMobile }: TOpenChatFromListItemParams): TThunkAction<void> =>
  (dispatch, getState) => {
    const state = getState();
    const currentOpenChatId = currentOpenChatIDSelector(state);
    const chats = selectChats(state);

    if (currentOpenChatId && !isMobile) {
      dispatch(sendMailingUxfeedbackCampaign());
    }

    dispatch(updateMessages(chatId));

    const chatUsers = chats.find(chat => chat.chatId === chatId)?.users;

    trackOpenChatListItemClick({
      chatId,
      opponentId: getChatUserByRole(chatUsers, 'opponent')?.userId,
      ownerId: getChatUserByRole(chatUsers, 'initiator')?.userId,
    });

    dispatch(updateChatImages({ chatId }));

    if (currentOpenChatId) {
      dispatch(increaseCountClosedChats());
    }
  };
